import angular from 'angular'

angular.module('nominas.calculo')
  .service('NominasCalculo', NominasCalculo);

function NominasCalculo() {
  function NominasCalculo() {
    let self = this;

  }

  return NominasCalculo;
}



// WEBPACK FOOTER //
// ./src/nominas/calculo/services/Calculo.js